/**** Email (un)obfuscation ****/
function deobfuscate(href) {
    var query_start = href.indexOf('?');
    var params = "";
    if (query_start != -1) params = href.substring(query_start);
    href = href.replace(/<\/?obs>/g,"");
    var components = href.match(/<obs_c>[^>]*<\/obs_c>/g);
    href = components.join("@");
    href = href.replace(/<\/?obs_c>/g,"");
    href = href.replace(/\[dot\]/g,".");
    return "mailto:"+href+params;
}
function process_mail_to_encoded_hrefs(element){
    [...element.querySelectorAll("*[href^='mailto:%3Cobs%3E']")].forEach(function(el){
        var href = decodeURIComponent(el.href);
        el.href = deobfuscate(href);
    });
}
function process_mail_to_hrefs(element){
    [...element.querySelectorAll("*[href^='mailto:<obs>']")].forEach(function(el){
        if (!el.href) return;
        var href = decodeURIComponent(el.href);
        el.href = deobfuscate(href);
    });
}
function process_obs_elements(element){
    [...element.querySelectorAll("obs")].forEach(function(el){
        var text = "";
        var index = 0;
        [...el.querySelectorAll("obs_c")].forEach(function(el){
            if (index > 0) text += "@";
            text += el.innerText.replace(/\[dot\]/gi,".");
            index++
        });
        el.insertAdjacentHTML('afterEnd', text);
        el.remove();
    });
}

function process_obfuscated_emails(element){
    process_obs_elements(element);
    process_mail_to_hrefs(element);
    process_mail_to_encoded_hrefs(element);
}

/* sites that load content after the initial page load should call this to process content that would
ordinarily get processed as the page loads */

export function process_content_for_browser(element){    
    if (!element)
        element = document.documentElement;
    process_obfuscated_emails(element);
    // TODO: Process galleries in post loaded content
}
